module.exports = __webpack_public_path__ + "static/media/Quran.59d58e6e.jpg";